<template>
    <div class=" ">
        <b-overlay :show="showoverlay" rounded="sm">
            <div class="row col-12 px-0 no-margin">

                <div class="">
                    <button class="mobile-toggle-btn" @click="sidebarOpen = !sidebarOpen">
                        <span v-if="!sidebarOpen">&#9776;</span>
                        <span v-else>&times;</span>
                    </button>
                </div>


                <div :class="['mobile-sidebar-wrapper', { open: sidebarOpen }]">

                    <div class="employee-sidebar px-0 col">
                        <div class="employee-sidebar-inner">
                            <div class="employee-portal-menu">
                                <div class="list-group">


                                    <div class="">
                                        <button type="button" class="list-group-item list-group-item-action"
                                            @click="swapComponent('employee-dashboard')"
                                            :class="{ 'menu-active': isActive('employee-dashboard') }">
                                            <span class="active">
                                                <img v-bind:src="media_url + 'dashboard.png'"
                                                    class="vsm--icon leftmenu mr-2" width="16px" />
                                                Dashboard</span>
                                        </button>
                                    </div>

                                    <div>
                                        <button type="button"
                                            class="list-group-item list-group-item-action list-item-main"
                                            @click="toggleSubmenu">
                                            <span class="active">
                                                <i class="fas fa-user mr-2"></i>
                                                Profile</span>
                                        </button>
                                        <div class="submenu-wrapper">
                                            <button type="button"
                                                class="list-group-item list-group-item-action list-item-sub"
                                                @click="swapComponent('account-employees-front')"
                                                :class="{ 'menu-active': isActive('account-employees-front') }">
                                                <span class="active">My Profile</span>
                                            </button>
                                            <button type="button"
                                                class="list-group-item list-group-item-action list-item-sub"
                                                @click="swapComponent('employee-contract-form')"
                                                :class="{ 'menu-active': isActive('employee-contract-form') }">
                                                <span class="active">My Contracts</span>
                                            </button>
                                        </div>
                                    </div>

                                    <div>
                                        <button v-if="company_access_settings['company_directory'] == true"
                                            type="button" class="list-group-item list-group-item-action"
                                            @click="swapComponent('company-directory-front')"
                                            :class="{ 'menu-active': isActive('company-directory-front') }">
                                            <span class="active"><img v-bind:src="media_url + 'Company-Users-blue.png'"
                                                    class="vsm--icon leftmenu mr-2 active" width="16px" /><img
                                                    v-bind:src="media_url + 'Company-Users-black.png'"
                                                    class="vsm--icon leftmenu mr-2 not-active" width="16px" />Company
                                                Directory</span>
                                        </button>
                                    </div>

                                    <!--<template  v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only'">
                                <div >
                                    <button type="button" class="list-group-item list-group-item-action" @click="swapComponent('employee-contract-form')" :class="{ 'menu-active': isActive('employee-contract-form') }">
                                        <span class="active"><img v-bind:src="media_url+'Contracts.png'"  class="vsm--icon leftmenu mr-2" width="16px"/>Contracts</span>
                                    </button>
                                </div>
                            </template>-->

                                    <template
                                        v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only'">
                                        <div>
                                            <button type="button"
                                                class="list-group-item list-group-item-action list-item-main"
                                                @click="toggleSubmenu">
                                                <span class="active">
                                                    <img v-bind:src="media_url + 'dollar-circle.png'"
                                                        class="vsm--icon leftmenu mr-2" width="16px" />
                                                    Payroll</span>
                                            </button>
                                            <div class="submenu-wrapper">
                                                <button v-if="company_access_settings['payslips'] == true" type="button"
                                                    class="list-group-item list-group-item-action list-item-sub"
                                                    @click="swapComponent('employeepayslips-front')"
                                                    :class="{ 'menu-active': isActive('employeepayslips-front') }">

                                                    <template
                                                        v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only'">
                                                        <span class="active">Payslips</span>
                                                    </template>
                                                    <template v-else> <span class="active">PF Slips</span></template>
                                                </button>
                                                <button v-if="company_access_settings['tax_cards'] == true"
                                                    type="button"
                                                    class="list-group-item list-group-item-action list-item-sub"
                                                    @click="swapComponent('employee-tax-cards')"
                                                    :class="{ 'menu-active': isActive('employee-tax-cards') }">

                                                    <template
                                                        v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only'">
                                                        <span class="active">
                                                            <!-- <img v-bind:src="media_url+'Tax.png'"  class="vsm--icon leftmenu mr-2" width="16px"/> -->
                                                            Tax Cards</span>
                                                    </template>
                                                    <template v-else><span class="active">Tax Cards</span> <i
                                                            class="fa fa-lock trz_lock_front_sidebar"
                                                            aria-hidden="true"></i></template>
                                                </button>
                                            </div>
                                        </div>
                                    </template>

                                    <template
                                        v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only'">
                                        <div>
                                            <button type="button"
                                                class="list-group-item list-group-item-action list-item-main"
                                                @click="toggleSubmenu">
                                                <span class="active">
                                                    <img v-bind:src="media_url + 'Taxes.png'"
                                                        class="vsm--icon leftmenu mr-2" width="16px" />
                                                    Taxes</span>
                                            </button>
                                            <div class="submenu-wrapper">
                                                <button v-if="company_access_settings['investments'] == true"
                                                    type="button"
                                                    class="list-group-item list-group-item-action list-item-sub"
                                                    @click="swapComponent('employee-investment-info-front')"
                                                    :class="{ 'menu-active': isActive('employee-investment-info-front') }">
                                                    <template
                                                        v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only'">
                                                        <span class="active">Investments</span>
                                                    </template>
                                                    <template v-else> <span class="active">Investments</span><i
                                                            class="fa fa-lock trz_lock_front_sidebar"
                                                            aria-hidden="true"></i></template>
                                                </button>
                                                <button v-if="company_access_settings['advance_income_tax'] == true"
                                                    type="button"
                                                    class="list-group-item list-group-item-action list-item-sub"
                                                    @click="swapComponent('employee-ait-info-front')"
                                                    :class="{ 'menu-active': isActive('employee-ait-info-front') }">

                                                    <template
                                                        v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only'">
                                                        <span class="active">Advance Income Tax</span>
                                                    </template>
                                                    <template v-else> <span class="active">Advance Income Tax</span><i
                                                            class="fa fa-lock trz_lock_front_sidebar"
                                                            aria-hidden="true"></i></template>
                                                </button>
                                            </div>
                                        </div>
                                    </template>

                                    <template
                                        v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only'">
                                        <div v-if="addons.includes('LeaveAttendances')">
                                            <button type="button"
                                                class="list-group-item list-group-item-action list-item-main"
                                                @click="toggleSubmenu">
                                                <span class="active">
                                                    <img v-bind:src="media_url + 'leave-attendance.png'"
                                                        class="vsm--icon leftmenu mr-2" width="16px" />
                                                    Leave and Attendance</span>
                                            </button>
                                            <div class="submenu-wrapper">
                                                <button v-if="company_access_settings['leave_attendances'] == true"
                                                    type="button"
                                                    class="list-group-item list-group-item-action list-item-sub"
                                                    @click="swapComponent('employee-leave-attendance-wrapper-front')"
                                                    :class="{ 'menu-active': isActive('employee-leave-attendance-wrapper-front') }">
                                                    <span class="active">Personal</span>
                                                </button>

                                                <button v-if="is_manager == true" type="button"
                                                    class="list-group-item list-group-item-action list-item-sub"
                                                    @click="swapComponent('leaveattendances-dashboard-front')"
                                                    :class="{ 'menu-active': isActive('leaveattendances-dashboard-front') }">
                                                    <span class="active">My Team</span>
                                                </button>
                                            </div>
                                        </div>
                                    </template>

                                    <template
                                        v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only'">
                                        <div v-if="loan_settings == 1">
                                            <button type="button"
                                                class="list-group-item list-group-item-action list-item-main"
                                                @click="toggleSubmenu">
                                                <span class="active">
                                                    <img v-bind:src="media_url + 'Loan-advance.png'"
                                                        class="vsm--icon leftmenu mr-2" width="16px" />
                                                    Loan and Advance</span>
                                            </button>
                                            <div class="submenu-wrapper">
                                                <button v-if="company_access_settings['loan_and_advance'] == true"
                                                    type="button"
                                                    class="list-group-item list-group-item-action list-item-sub"
                                                    @click="swapComponent('employee-loan-list-front')"
                                                    :class="{ 'menu-active': isActive('employee-loan-list-front') }">
                                                    <span class="active">Personal</span>
                                                </button>

                                            </div>
                                        </div>
                                    </template>

                                    <div v-if="addons.includes('Pf')">
                                        <button v-if="company_access_settings['provident_fund'] == true" type="button"
                                            class="list-group-item list-group-item-action list-item-main"
                                            @click="toggleSubmenu">
                                            <span class="active">
                                                <img v-bind:src="media_url + 'provident-fund.png'"
                                                    class="vsm--icon leftmenu mr-2" width="16px" />
                                                Provident Fund</span>
                                        </button>
                                        <div class="submenu-wrapper">
                                            <button v-if="company_access_settings['provident_fund'] == true"
                                                type="button"
                                                class="list-group-item list-group-item-action list-item-sub"
                                                @click="swapComponent('employee-pf-contributions')"
                                                :class="{ 'menu-active': isActive('employee-pf-contributions') }">
                                                <span class="active">PF Schedule</span>
                                            </button>
                                            <!-- <button v-if="company_access_settings['provident_fund'] == true" type="button" class="list-group-item list-group-item-action list-item-sub" @click="swapComponent('employee-pf-statement-front')" :class="{ 'menu-active': isActive('employee-pf-statement-front') }">
                                        <span class="active">PF Statement</span>
                                    </button> -->
                                            <button v-if="company_access_settings['provident_fund_loan'] == true"
                                                type="button"
                                                class="list-group-item list-group-item-action list-item-sub"
                                                @click="swapComponent('pf-employee-loan-list-front')"
                                                :class="{ 'menu-active': isActive('pf-employee-loan-list-front') }">
                                                <span class="active">PF Loan</span>
                                            </button>

                                            <!-- <template  v-if="$atl_company_package_title == 'Provident Fund Only'">
                                        <button v-if="company_access_settings['provident_fund_loan'] == true" type="button" class="list-group-item list-group-item-action list-item-sub pr-0" @click="swapComponent('pf-employee-loan-application-approve-list-front')" :class="{ 'menu-active': isActive('pf-employee-loan-application-approve-list-front') }">
                                            <span class="active">Loan Applications</span> <span v-if="approval_pending_data.pf > 0" class="notification">{{approval_pending_data.pf}}</span>
                                        </button>
                                    </template>
                                    <template  v-if="$atl_company_package_title == 'Provident Fund Only'">
                                        <button v-if="company_access_settings['provident_fund'] == true" type="button" class="list-group-item list-group-item-action list-item-sub pr-0" @click="swapComponent('pf-employee-settlement-approve-list-front')" :class="{ 'menu-active': isActive('pf-employee-loan-application-approve-list-front') }">
                                            <span class="active">Settlements</span> <span v-if="approval_pending_data.pf_settlement > 0" class="notification">{{approval_pending_data.pf_settlement}}</span>
                                        </button> 
                                    </template> -->
                                        </div>
                                    </div>

                                    <div v-if="addons.includes('Gf')">
                                        <button type="button"
                                            class="list-group-item list-group-item-action list-item-main"
                                            @click="toggleSubmenu">
                                            <span class="active"><img v-bind:src="media_url + 'gratuity-fund.png'"
                                                    class="vsm--icon leftmenu mr-2" width="16px" />Gratuity Fund</span>
                                        </button>
                                        <div class="submenu-wrapper">
                                            <button type="button"
                                                class="list-group-item list-group-item-action list-item-sub"
                                                @click="swapComponent('employee-gf-contributions-front')"
                                                :class="{ 'menu-active': isActive('employee-pf-contributions') }">
                                                <span class="active">GF Schedule</span>
                                            </button>
                                        </div>
                                    </div>
                                    <template
                                        v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only'">

                                        <div>
                                            <button type="button" class="list-group-item list-group-item-action"
                                                @click="swapComponent('employee-documents-front')"
                                                :class="{ 'menu-active': isActive('employee-documents-front') }">
                                                <span class="active">
                                                    <img v-bind:src="media_url + 'Documents.png'"
                                                        class="vsm--icon leftmenu mr-2" width="16px" />
                                                    Documents</span>
                                            </button>
                                        </div>
                                    </template>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="employee-content main col-12 login-left" v-if="showRegister">
                    <div :is="currentComponent" :flg="1" :addons="this.addons" :employee_id="this.employee_id"
                        v-on:childToParent="setComponent" v-if="component_clicked"></div>
                    <div v-else>
                        <div class="row no-gutters py-2 mb-3 ml-3">
                            <div class="col-md-10 col-sm-12">
                                <h4 class="atlhr-dashboard-title mt-10"><span class="blue-title">Reset</span> Your
                                    Password<span><a v-bind:href="$api_url">Dashboard</a> / Reset Password</span></h4>
                            </div>
                        </div>

                        <div class="users-style ml-3">
                            <div class="form-wrapper pt-1">
                                <b-form @submit.stop.prevent="onSubmit">

                                    <b-form-group id="old_password-group" label="Old Password *" label-for="old_password">
                                        <b-form-input id="old_password" name="old_password" placeholder="Password"
                                            type="password" v-model="fdata.old_password" v-validate="{ required: true }"
                                            :state="validateState('old_password')"
                                            aria-describedby="old_password-feedback"
                                            data-vv-as="Old Password"></b-form-input>
                                        <b-form-invalid-feedback id="old_password-feedback">{{
                                            veeErrors.first('old_password')
                                            }}</b-form-invalid-feedback>
                                    </b-form-group>

                                    <b-form-group id="password-group" label="New Password *" label-for="password">
                                        <b-form-input id="password" name="password" placeholder="Password"
                                            type="password" v-model="fdata.password"
                                            v-validate="{ required: true, min: 8 }" :state="validateState('password')"
                                            aria-describedby="password-feedback"
                                            data-vv-as="New Password"></b-form-input>
                                        <b-form-invalid-feedback id="password-feedback">{{ veeErrors.first('password')
                                            }}</b-form-invalid-feedback>
                                    </b-form-group>

                                    <b-form-group id="password_confirmation-group" label="Confirm Password *"
                                        label-for="password_confirmation">
                                        <b-form-input id="password_confirmation" name="password_confirmation"
                                            placeholder="Password Confirmation" type="password" autocomplete="off"
                                            v-model="fdata.password_confirmation"
                                            v-validate="{ required: true, confirmed: fdata.password }"
                                            :state="validateState('password_confirmation')"
                                            aria-describedby="password_confirmation-feedback"
                                            data-vv-as="Confirm Password"></b-form-input>
                                        <b-form-invalid-feedback id="password_confirmation-feedback">{{
                                            veeErrors.first('password_confirmation') }}</b-form-invalid-feedback>
                                    </b-form-group>

                                    <b-form-group id="">
                                        <b-button type="submit" variant="primary" class="float-left">Update
                                            Password</b-button>
                                        <a type="link" variant="primary" class="float-right blue-variant"
                                            :href="this.$api_url">Back to
                                            Dashboard</a>
                                    </b-form-group>
                                </b-form>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </b-overlay>




    </div>

</template>
<script>
import VueRecaptcha from 'vue-recaptcha';
export default {

    mounted() {
        //console.log('login form info started..');   
        //console.log(this.data);  
    },
    components: {
        'vue-recaptcha': VueRecaptcha,
    },
    data() {

        return {

            successmsg: '',
            errormsg: [],
            fdata: { old_password: null, password: null, password_confirmation: null },

            showoverlay: false,

            showRegister: true,
            verification_code: null,
            captcha_verify: false,

            accept_status: null,

            //sitekey: '6LdOYzsbAAAAAOvXGo3cpT1A_m6dsYEEcLczJMCa',
            sitekey: '6Leg2jMqAAAAAD_UnKTKkLpPof4VETXi8nBo7nU0',

            activeItem: '',
            currentComponent: '',

            media_url: this.$api_url + '/images/menu/',
            public_info: [],
            avatarsrc: '',



            company_assigned: false,
            no_company_message: '',
            dCompanyId: 0,
            employees: [],

            length: 20,
            addons: [],
            employee_id: '',
            loan_settings: '',
            company_access_settings: {},

            is_manager: false,
            component_clicked: false,

             sidebarOpen: false    // sidebar condition mahmud

        }
    },
    methods: {

        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetvalidator() {
            this.$validator.reset();
        },
        validateEmail(email) {
            var re = /\S+@\S+\.\S+/;
            return re.test(email);
        },
        resetForm() {
            this.fdata = {

                //asd:null,
            };

            this.$nextTick(() => {
                this.$validator.reset();
            });
        },
        onVerify: function (response) {
            //console.log('Verify: ' + response);
            this.captcha_verify = true;

        },
        onExpired: function () {
            //console.log('Expired')
            this.captcha_verify = false;
        },
        resetRecaptcha() {
            this.$refs.recaptcha.reset() // Direct call reset method
        },
        onSubmit(e) {
            if (!this.checkNet()) return false;

            let submitUrl = submitUrl = this.$api_url + '/employee/password/reset';


            /*currentObj.$bvToast.toast('On Progress' , {
                                        title: `Saved`,
                                        variant: 'info',
                                        solid: true
                                    });

            
            this.showoverlay = false; 
            return false;*/


            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                //this.showoverlay = true; 

                e.preventDefault();
                let currentObj = this;

                let formData = new FormData();

                for (let [key, value] of Object.entries(this.fdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                    //console.log(`${key}: ${value}`);
                }

                axios.post(submitUrl, formData)
                    .then(function (response) {
                        this.showoverlay = false;
                        if (response.data.flg == 1) {
                            currentObj.$bvToast.toast('Password Reset Done.', {
                                title: `Info`,
                                variant: 'info',
                                solid: true,
                                toaster: 'b-toaster-top-center',
                            });


                            setTimeout("location.href = '" + this.$api_url + "';", 1500);
                        }
                        else {
                            currentObj.$bvToast.toast('Wrong Old Password.', {
                                title: `Info`,
                                variant: 'danger',
                                solid: true,
                                toaster: 'b-toaster-top-center',
                            });

                        }



                    }.bind(this))
                    .catch(function (error) {
                        this.showoverlay = false;
                        //this.errormsg = error;
                        currentObj.serverError(error);

                    });
            });
        },

        get_access_settings: function () {
            // 
            if (!this.checkNet()) return false;
            axios.get(this.$api_url + '/front/company/employee-access-settings', {
            }).then(function (response) {

                let company_access_settings_temp = {};
                company_access_settings_temp = response.data;

                for (const [key, value] of Object.entries(company_access_settings_temp)) {

                    if (value == 1) {
                        company_access_settings_temp[key] = true;
                    }
                    else {
                        company_access_settings_temp[key] = false;
                    }

                }

                this.company_access_settings = company_access_settings_temp;

            }.bind(this));
        },

        swapComponent: function (component_name) {
            //
            let formData = new FormData();
            formData.append('sess', 'subordinate_id');
            axios.post(this.$api_url + '/front/flushsess', formData)
                .then(function (response) {

                }.bind(this))
                .catch(function (error) {
                    currentObj.serverError(error);
                });


            this.currentComponent = component_name;
            this.$cookies.set("last_clicked_component", component_name);
            this.activeItem = component_name;
            this.component_clicked = true;
              this.sidebarOpen = false;     // mahmud added for refresh sidebar
        },
        setComponent: function (x) {
            if (x.component_name)
                this.swapComponent(x.component_name);
        },
        isActive: function (menuItem) {

            return this.activeItem === menuItem;
            // // return this.activeItem === this.currentComponent;
            // return this.currentComponent;

        },
        getEmployeePublicData: function () {
            if (!this.checkNet()) return false;
            axios.get(this.$api_url + '/front/employee/front/publicinfo', {
                params: {

                }
            }).then(function (response) {
                if (response.data) {
                    this.company_assigned = true;
                    this.public_info = response.data;
                    this.employee_id = this.public_info.employee_id;
                    this.dCompanyId = this.public_info.company_id;

                    if (this.public_info.pic != '')
                        this.avatarsrc = this.$api_url + '/images/employee/' + this.public_info.company_id + '/' + this.public_info.pic;
                    else
                        this.avatarsrc = this.$api_url + '/images/employee/demo.jpg';
                }
                else {
                    this.company_assigned = false;
                    this.no_company_message = 'As soon as you are associated with any company, you will be able to see all data accordingly!';
                }



            }.bind(this));
        },

        getCompanyData: function () {
            if (!this.checkNet()) return false;
            axios.get(this.$api_url + '/front/company/details', {
                params: {
                    //id: x
                }
            }).then(function (response) {

                if (response.data.length != 0) {
                    this.company_id = response.data.id;
                    this.logosrc = this.$api_url + '/images/company/' + response.data.logo;

                    this.companyname = response.data.name;

                    this.addons = response.data.module_disabled;
                    this.loan_settings = response.data.loan_settings;

                    if (response.data.no_of_employees == 0)
                        this.employee_err = true;

                    if ((response.data.tin == '') || (response.data.tax_zone == '') || (response.data.tax_circle == ''))
                        this.overview_err = true;
                    /*
                    companyname:'',                
                    companyaddress:'',  */

                }

            }.bind(this));


        },

        checkIsManager: function () {
            if (!this.checkNet()) return false;

            axios.get(this.$api_url + '/front/ismanager', {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {
                //alert(response.data);
                if (response.data == 1)
                    this.is_manager = true;

            }.bind(this)).catch(function (error) { this.serverError(error); });

        },
        flusSubordinate: function () {

            let formData = new FormData();
            formData.append('sess', 'subordinate_id');
            axios.post(this.$api_url + '/front/flushsess', formData)
                .then(function (response) {

                }.bind(this));
        },

        toggleSubmenu: function (event) {
            //this.submenu_active = !this.submenu_active;
            if (event) {
                event.target.classList.toggle('active')
            }
        },

    },
    created: function () {
        this.get_access_settings();
        this.getEmployeePublicData();
        this.getCompanyData();


        this.checkIsManager();
        this.flusSubordinate();

        /* if(this.$cookies.isKey("last_clicked_component"))
        {
            
            if(this.$cookies.get("last_clicked_component") != null)
            {
                let component_name = this.$cookies.get("last_clicked_component");
                this.currentComponent = component_name;
                this.activeItem = component_name;
            }
                
        } */
    },

    watch: {
        sidebarOpen(newVal) {
            if (newVal) {
                document.body.classList.add('mobile-sidebar-open');
            } else {
                document.body.classList.remove('mobile-sidebar-open');
            }
        }
    }
}
</script>
<style>
ul.login-tabs-nav.nav-pills {
    border: none !important;
}

ul.login-tabs-nav.nav-pills li a,
ul.login-tabs-nav.nav-pills li:last-child a {
    border: 1px solid #464d5c !important;
}

ul.login-tabs-nav.nav-pills li a.active {
    border: 1px solid #3490dc !important;
}

ul.login-tabs-nav.nav-pills li,
ul.login-tabs-nav.nav-pills li a {
    color: #dee6ff;
}

.login-tabs-nav .nav-item:last-child a {
    border-top-right-radius: 0.25rem !important;
    border-bottom-right-radius: 0.25rem !important;
}

.login-tabs-nav .nav-item:first-child a {
    border-top-left-radius: 0.25rem !important;
    border-bottom-left-radius: 0.25rem !important;
}
</style>
